import * as React from 'react';
import { Card } from 'react-bootstrap';
import { EventExtendedViewRow } from 'cb-model';

interface EventSpecialtiesCardProps {
  event: EventExtendedViewRow;
}

export const EventSpecialtiesCard = (props: EventSpecialtiesCardProps): React.JSX.Element => {
  return (
    <Card>
      <Card.Header>Specialties</Card.Header>
      <Card.Body>
        {props.event.specialty_group && <div>{snakeCaseToDisplay(props.event.specialty_group)}</div>}
        {props.event.specialties && <div>{snakeCaseToDisplay(props.event.specialties)}</div>}
      </Card.Body>
    </Card>
  );
};

const snakeCaseToDisplay = (raw: string) =>
  raw
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
